import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";

import {
  MainHolder,
  Children,
  Body,
  StyledText,
} from "../../../components/common/basic";

import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import { BackButton } from "../../../components/common";
import RewardItemCard from "./components/RewardItemCard";
import useMashupNWinOrders from "./hooks/useMashupnWinOrders";

const MashupAndWinOrders = () => {
  useEffect(() => {
    analytics().then(anl => logEvent(anl, "screen_view", {
      firebase_screen: "MashupAndWinOrders",
      firebase_screen_class: "MashupAndWinOrders",
    }));
  }, []);

  const {
    background,
    history,
    mashupnWinOrders,
    mashupRewardItems,
    unitPoints,
  } = useMashupNWinOrders();

  return (
    <>
      <MainHolder>
        <Children>
          <BackButton
            onClick={() => {
              history.goBack();
            }}
          />
          <Header>
            <div style={{ textAlign: 'center' }}>
              <StyledText size={24} style={{ fontFamily: 'MTNMedium' }} margin="0">{'Orders'}</StyledText>
            </div>
          </Header>
          <Body>
            <div style={{ boxSizing: 'border-box', padding: '0 15px' }}>
              {
                mashupnWinOrders && mashupnWinOrders.length > 0 && mashupnWinOrders.map(({ itemId, orderId, status }, index) => {
                  const { image, name, amount } = mashupRewardItems.find(item => item.id === itemId) || {};
                  return (
                    <RewardItemCard
                      onClick={() => {
                        history.push(`/mashupnwin/order-details/${orderId || index}`)
                      }}
                      color={background}
                      image={image}
                      name={name}
                      points={amount * unitPoints}
                      showStatus={true}
                      status={status}
                    />
                  )
                })
              }
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default MashupAndWinOrders;
